import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-shipra',
  templateUrl: './shipra.component.html',
  styleUrls: ['./shipra.component.scss']
})
export class ShipraComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getShipra();
  }

}
